import React, { useEffect, useState } from "react";

/** Wraps page content with a tiny fade/slide transition on key change. */
export const PageTransition = ({ pageKey, children }) => {
    const [k, setK] = useState(pageKey);
    const [phase, setPhase] = useState("enter"); // "enter" | "exit"

    useEffect(() => {
        if (pageKey === k) return undefined;
        setPhase("exit");
        const t = setTimeout(() => {
            setK(pageKey);
            setPhase("enter");
            // Force the new page to start at the top — covers the case where
            // the previous page was scrolled deep on mobile. We do this here
            // (at the content-swap moment) AS WELL AS in App.js so we win
            // against any browser quirk or layout-height shift mid-transition.
            try { window.scrollTo(0, 0); } catch (_) {}
            if (document.documentElement) document.documentElement.scrollTop = 0;
            if (document.body) document.body.scrollTop = 0;
        }, 180);
        return () => clearTimeout(t);
    }, [pageKey, k]);

    return (
        <div className={`page-transition ${phase}`} data-testid="page-transition" data-phase={phase}>
            {children}
        </div>
    );
};

export default PageTransition;
